'use strict'

import * as THREE from "three";
import { projectMode, settingsData, threeJsVariables } from '../../settings';
import {rotateToCamera} from "../controls/orbitControls";
import {SelectedObjectType, ViewMode} from '../../common';

export const createStreetNames = () => {

    if (projectMode.LiteMode.isActive()) return;

    const rtl = document.documentElement.getAttribute('dir') === 'rtl';
    const fontLoader = new THREE.FontLoader();

    if (threeJsVariables.scene.getObjectByName('streetsGroup')?.children?.length > 0) {
        threeJsVariables.scene.getObjectByName('streetsGroup').children.forEach(child => {
                child.geometry.dispose();
                child.material.dispose();
                threeJsVariables.scene.getObjectByName('streetsGroup').remove(child);
        });

        threeJsVariables.scene.remove(threeJsVariables.scene.getObjectByName('streetsGroup'));
    }

    const streetsGroup = new THREE.Group();
    streetsGroup.name = 'streetsGroup';

    if (settingsData.activeViewMode !== ViewMode.Orbit){
      streetsGroup.visible = false;
    }

    fontLoader.load('fonts/assistant/Assistant_Regular.json', (font) => {
        config.features.streets.forEach(street => {
            let message;
            if (rtl) {
                message = street.name.he;
                let messageArray = street.name.he.split('');
                message = '';
                messageArray.reverse().forEach(letter => message += letter);
            } else {
                message = street.name.en;
            }


            const textGeometry = new THREE.TextBufferGeometry(
                message,
                {
                    font: font,
                    size: 0.5,
                    height: 0.2,
                    curveSegments: 6,
                    bevelEnabled: true,
                    bevelThickness: 0.03,
                    bevelSize: 0.02,
                    bevelOffset: 0,
                    bevelSegments: 4,
                }
            );

            textGeometry.center();
            const material = new THREE.MeshMatcapMaterial();
            const text = new THREE.Mesh(textGeometry, material);

            text.name = `Street-${street.name.en}`;
            text.position.set(0, 0, 0);
            text.rotation.set(0, 0, 0);
            text.scale.set(street.scale.x, street.scale.y, street.scale.z);

            // streetsGroup.add(text);

            makeInstanceTextMesh(text, street.instances.length, street.instances, streetsGroup);

            if (settingsData.activeModeSwitching){
                streetsGroup.visible = false;
            }

        });

        threeJsVariables.scene.add(streetsGroup);
    });
}


function makeInstanceTextMesh(baseMesh, count, instanceConfig, streetsGroup) {
    const matrix = new THREE.Matrix4();
    const scale = new THREE.Vector3(baseMesh.scale.x, baseMesh.scale.y, baseMesh.scale.z);
    const textInstance = new THREE.InstancedMesh(baseMesh.geometry, baseMesh.material, count);
    textInstance.instanceMatrix.setUsage(THREE.DynamicDrawUsage);

    instanceConfig.forEach((element, index) => {
        let rotation = new THREE.Euler(element.rotation.x, element.rotation.y, element.rotation.z, 'XYZ');
        let rotationQ = new THREE.Quaternion().setFromEuler(rotation);
        let position = new THREE.Vector3(element.position.x, element.position.y, element.position.z);
        matrix.compose(position, rotationQ, scale);
        textInstance.name = `${baseMesh.name}-${index}_instance`;
        textInstance.setMatrixAt(index, matrix);

        streetsGroup.add(textInstance);

    })

    return streetsGroup;
}

export const toggleStreetNames = (show) => {
    const group = threeJsVariables.scene.getObjectByName('streetsGroup');

    if (!group) return;

    group.visible = show;
}

export const rotateStreetNames = () => {
    const group = threeJsVariables.scene.getObjectByName('streetsGroup');
    if (!group) return;

    const indicator = rotateToCamera();

    group.traverse(child => {

        if (child.type === 'Group') return;

        if (indicator > 1.5) {
           child.rotation.z = 1.2;
       } else if (indicator < 1.5) {
            child.rotation.z = -2;
        }

    })
}
